import Axios from "axios";
import { PATH } from "../../envs/core";
import { historic } from "../../constants/api";
export const getResultOrigin = (year, type, electionNumber, placeId = "C108") => {
  return Axios.get("".concat(PATH).concat(historic, "/").concat(year, "/").concat(type, "/").concat(electionNumber, "/").concat(placeId)).then(({
    data
  }) => data);
};